var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94329 2.66184C3.72751 2.44605 3.37766 2.44605 3.16188 2.66184C2.9461 2.87762 2.9461 3.22747 3.16188 3.44325L7.71859 7.99998L3.16184 12.5567C2.94605 12.7725 2.94605 13.1224 3.16184 13.3382C3.37762 13.5539 3.72747 13.5539 3.94325 13.3382L8.50001 8.7814L13.0567 13.3381C13.2725 13.5539 13.6224 13.5539 13.8382 13.3381C14.0539 13.1224 14.0539 12.7725 13.8382 12.5567L9.28143 7.99998L13.8381 3.44327C14.0539 3.22749 14.0539 2.87764 13.8381 2.66185C13.6223 2.44607 13.2725 2.44607 13.0567 2.66185L8.50001 7.21856L3.94329 2.66184Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.4e2b48adf9eadf8c31b9bf80f62f5325.svg";
export { ForwardRef as ReactComponent };